import React from "react";
import { services, usps } from "../mock";
import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

export default function Services() {
  return (
    <section id="tjanster" className="hpr-blue-tint py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="reveal text-center max-w-2xl mx-auto">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#1B45C4]">Våra tjänster</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900">Allt för ett rent & skyddat tak</h2>
          <p className="mt-4 text-slate-600 text-lg">Tre specialiteter – ett och samma proffsgäng. Välj det ditt tak behöver.</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => {
            const Icon = s.icon;
            const targets = { taktvatt: "/taktvatt-stockholm", kombi: "/takmalning-stockholm", solcellstvatt: "/solcellstvatt-stockholm", nocktatning: "#kalkylator" };
            const target = s.link || targets[s.id] || "#kontakt";
            const isRoute = target.startsWith("/");
            const cardCls = "reveal group flex flex-col rounded-3xl bg-white ring-1 ring-slate-100 overflow-hidden transition-all hover:shadow-2xl hover:shadow-[#1B45C4]/15 hover:-translate-y-1.5 cursor-pointer";
            const inner = (
              <>
                <div className="relative h-52 overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <span className="absolute top-4 left-4 rounded-full bg-white/95 px-3 py-1 text-xs font-bold text-[#1B45C4]">{s.tag}</span>
                </div>
                <div className="flex flex-col flex-1 p-7">
                  <div className="flex items-center gap-3">
                    <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#38BDF8]/15">
                      <Icon className="w-6 h-6 text-[#1B45C4]" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900">{s.title}</h3>
                  </div>
                  <p className="mt-4 text-slate-600 text-[15px]">{s.desc}</p>
                  <ul className="mt-5 space-y-2">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-center gap-2 text-sm font-medium text-slate-700">
                        <Check className="w-4 h-4 text-[#38BDF8]" /> {p}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-6 pt-5 border-t border-slate-100 flex items-center justify-between">
                    <div>
                      <p className="text-xs text-slate-400">Pris</p>
                      <p className="text-lg font-extrabold text-slate-900">{s.price}</p>
                    </div>
                    <span className="inline-flex items-center rounded-full bg-[#ffffff] group-hover:bg-[#e6edff] px-4 py-2 text-[#1B45C4] font-semibold text-sm transition-colors ring-1 ring-[#e6edff]">
                      {s.id === "kombi" ? "Välj färg" : isRoute ? "Läs mer" : "Boka"} <ArrowRight className="ml-1.5 w-4 h-4" />
                    </span>
                  </div>
                </div>
              </>
            );
            return isRoute
              ? <Link key={s.id} to={target} data-testid={`service-card-${s.id}`} className={cardCls}>{inner}</Link>
              : <a key={s.id} href={target} data-testid={`service-card-${s.id}`} className={cardCls}>{inner}</a>;
          })}
        </div>

        <p className="reveal mt-8 text-center text-slate-600">
          Vill du motverka ny påväxt? <Link to="/takbehandling-stockholm" data-testid="services-treatment-link" className="font-bold text-[#1B45C4] hover:underline">Läs om takbehandling i Stockholm</Link>.
        </p>

        <div className="mt-8 grid sm:grid-cols-3 gap-4">
          {usps.map((u) => {
            const Icon = u.icon;
            return (
              <div key={u.title} className="reveal flex items-start gap-3 rounded-2xl bg-white p-5 ring-1 ring-slate-100">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#38BDF8]/15">
                  <Icon className="w-5 h-5 text-[#1B45C4]" />
                </div>
                <div>
                  <p className="font-bold text-slate-900">{u.title}</p>
                  <p className="text-sm text-slate-600">{u.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
